import Splide from "@splidejs/splide";
import SplideVideo from "@splidejs/splide-extension-video";

const slideShow = (slide) => {
// Create and mount the thumbnails slider.
    const thumbnailSlider = new Splide( '#js-thumbnail-slider', {
        rewind      : true,
        fixedWidth  : 100,
        fixedHeight : 64,
        isNavigation: true,
        gap         : 10,
        focus       : 'left',
        arrows     : false,
        pagination  : false,
        cover       : true,
        breakpoints : {
            '600': {
                fixedWidth  : 66,
                fixedHeight : 40,
            }
        }
    } ).mount();

// Create the main slider.
    const primarySlider = new Splide( '#js-primary-slider', {
        type: 'fade',
        pagination: false,
        arrows: false,
        heightRatio: 0.5625,
        // cover      : true,
        video: {
            autoplay: false,
            hideControls: false,
            disableOverlayUI: false,
            playerOptions: {
                htmlVideo: {
                    playsinline: true,
                },
            }
        },
    } );

// Set the thumbnails slider as a sync target and then call mount.
    primarySlider.sync( thumbnailSlider ).mount({SplideVideo});

}

export default slideShow
